/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, Fragment } from "react";
import { Clear } from "@material-ui/icons";
import { Tooltip } from "@material-ui/core";
import {
  containerCss,
  deleteButtonCss,
  imgCss,
  labelCss,
  thumbCss,
  thumbInnerCss,
} from "./FileList.styles";
import { getFileBlob } from "./utils";

export type Props = {
  files: File[];
  onDelete: (index: number) => void;
};

const FileList: FC<Props> = ({ files, onDelete }) => {
  const renderFileTile = (file: File, index: number) => {
    const isImg = file.type.startsWith("image");
    const sizeText = `${Math.ceil(file.size / 1024)}KB`;

    const tooltipTitle = (
      <Fragment>
        {file.name}
        <br />
        {sizeText}
        <br />
        {file.type}
      </Fragment>
    );

    return (
      <div
        css={thumbCss}
        key={`${file.name}-${file.size}-${file.type}-${file.lastModified}`}
      >
        <Tooltip title={tooltipTitle}>
          <div css={thumbInnerCss}>
            {isImg && (
              <img alt={file.name} src={getFileBlob(file)} css={imgCss} />
            )}
            {!isImg && <div css={labelCss}>{tooltipTitle}</div>}
            <Clear css={deleteButtonCss} onClick={() => onDelete(index)} />
          </div>
        </Tooltip>
      </div>
    );
  };

  return <div css={containerCss}>{files.map(renderFileTile)}</div>;
};

export default FileList;
export type FileListProps = Props;
